<template>
  <OmtRow border-radius="8px" padding="16px" bg="var(--colors-light-primary-light-gray)" flex-direction="column">
    <CFlex>
      <OmtIcons name="circle-exclamation" mr="8px" />
      <OmtTypography as="h2-bold" color="var(--colors-light-primary-gray)">{{ title }}</OmtTypography>
    </CFlex>
    <OmtRow mt="14px"> <slot></slot></OmtRow>
  </OmtRow>
</template>

<script>
export default {
  name: "SacCardInfo",
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>
